/* eslint-disable react/jsx-pascal-case */
import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {withSnackbar} from "notistack";
import {hideError, hideSnackbar} from "../redux/notify/notifyActions";
import Icons from './Icons';
import IconButton from "@material-ui/core/IconButton";

class Notifier extends React.Component {

    componentDidUpdate(prevProps, prevState, snapshot) {
        const enqueueSnackbar = this.props['enqueueSnackbar'];
        const error = this.props['error'];
        const snackbar = this.props['snackbar'];
        const closeSnackbar = this.props['closeSnackbar'];

        const action = (key) => (
            <Fragment>
                <IconButton onClick={() => {
                    closeSnackbar(key)
                }}>
                    <Icons.close color="action"/>
                </IconButton>
            </Fragment>
        );

        if (error) {
            error.split('\n').forEach(errorPart => {
                enqueueSnackbar(errorPart, {
                    variant: 'error',
                    persist: true,
                    action
                });
            });
            hideError();
        }

        if (snackbar && snackbar.message) {
            snackbar.message.split('\n').forEach(snackbarPart => {
                enqueueSnackbar(snackbarPart, {
                    ...snackbar.properties,
                    variant: 'success',
                    persist: false,
                    action
                });
            });
            hideSnackbar();
        }
    }

    render() {
        const children = this.props['children'];
        return children;
    }

}

const mapState = (state) => {
    return {
        error: state.notify.error,
        snackbar: state.notify.snackbar
    };
};

export default withSnackbar(connect(mapState)(Notifier));
